var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProgressBarFinishPoleRightinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2,
  height: 29.003,
  viewBox: "0 0 1.524 29.003"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 810"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1233",
  d: "M.762 28.817c-.282 0-.51-.163-.51-.363V1.587c0-.2.228-.363.51-.363s.51.163.51.363v26.867c0 .2-.228.363-.51.363",
  fill: "#eba47f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1234",
  d: "M.762 29.003c-.42 0-.762-.245-.762-.546V1.428c0-.3.342-.546.762-.546s.7-1.132.7-.831l.062 28.406c0 .3-.342.546-.762.546m0-27.76c-.142 0-.258.083-.258.185v27.029c0 .1.116.185.258.185s.258-.083.258-.185V1.428c0-.1-.116-.185-.258-.185",
  fill: "#333548"
}))));
export default SvgProgressBarFinishPoleRightinline;